import { render, staticRenderFns } from "./customer-diecutters.component.vue?vue&type=template&id=5206d6b0&scoped=true&"
import script from "./customer-diecutters.component.ts?vue&type=script&lang=ts&"
export * from "./customer-diecutters.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer-diecutters.component.scss?vue&type=style&index=0&id=5206d6b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206d6b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VDataTable,VIcon})
